/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonButton, IonContent, IonLabel, IonRow, NavParams } from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { UI } from 'src/app/core/helpers/ui';
import { BasePopover } from 'src/app/shared/components/base-popover/base.popover';

@Component({
  templateUrl: 'sadad.popover.html',
  styleUrls: ['sadad.popover.scss'],
  imports: [FormsModule, TranslatePipe, IonLabel, IonContent, IonButton, IonRow],
})
export class SadadPopoverComponent extends BasePopover {
  private params = inject(NavParams);
  private ui = inject(UI);

  identifier: string;
  billNumber: number;

  constructor() {
    super();
    const params = this.params;
    this.identifier = params.get('identifier');
    this.billNumber = +params.get('billNumber');
  }

  public copyBillNumber(element: HTMLInputElement) {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(this.billNumber.toString())
        .then(() => {
          this.ui.showToast(this.translation.Payment.TheInvoiceNumberHasBeenCopied);
        })
        .catch(() => {
          this.ui.showToast(this.translation.Errors.FailedToCopyBillNumberToClipboard as string);
        });
    } else {
      // use old commandExec() way
      element.select();
      document.execCommand('copy');
      this.ui.showToast(this.translation.Payment.TheInvoiceNumberHasBeenCopied);
    }
  }
}
